import { render, staticRenderFns } from "./ToolsPanel.vue?vue&type=template&id=4796e17c&"
import script from "./ToolsPanel.ts?vue&type=script&lang=ts&"
export * from "./ToolsPanel.ts?vue&type=script&lang=ts&"
import style0 from "./ToolsPanel.vue?vue&type=style&index=0&id=4796e17c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports